const handleMobileSubmenu = () => {
  const submenuBtns = [
    ...document.querySelectorAll('.menu-item-has-children > a'),
  ];
  const submenus = [
    ...document.querySelectorAll('.menu-item-has-children > .sub-menu'),
  ];

  const menusHeights = submenus.map((menu) => {
    const height = menu.clientHeight;
    menu.style.height = `${0}px`;

    return height;
  });

  const handleClick = ({ target }) => {
    const targetIndex = submenuBtns.indexOf(target);

    if (targetIndex !== -1) {
      const currentSubmenu = submenus[targetIndex];
      const currentSubmenuHeight = currentSubmenu.clientHeight;
      const currentSubmenuInitialHeight = menusHeights[targetIndex];

      currentSubmenu.style.height =
        currentSubmenuHeight === 0
          ? `${currentSubmenuInitialHeight}px`
          : `${0}px`;
    }
  };

  submenuBtns.forEach((btn) => {
    btn.addEventListener('click', handleClick);
  });
};

export default handleMobileSubmenu;
